<template>
  <div id="root-page">
    <AppHeader />
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import AppHeader from "./components/AppHeader.vue";

/**
 * This is the actual vue application.
 */
export default defineComponent({
  name: "RootPage",

  components: {
    AppHeader,
  },
});
</script>
